module.exports = "/assets/82427b06ab19c41541d7864944d1e2e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/8L.png
// module id = 2269
// module chunks = 0